<template>
    <el-dialog title="可快捷导出的模板" width="50%"
               :close-on-click-modal="false"
               append-to-body :visible.sync="visible" @close="close()">
        <div v-loading="loading">
            <div class="flex_b_c m_b1">
                <div>总模板数：{{list.length}}</div>
                <el-button size="small" type="primary" @click="addEdit(null, 'add')">新增模板</el-button>
            </div>
            <draggable v-model="list" element="tbody" class="block" :options="{animation: 150, handle: '.allowDrag'}" @end="onEnd">
                <div class="flex_l_c m_b1" v-for="(item,index) in list" :key="index">
                    <el-input v-model.trim="item.name" size="small" maxlength="10" disabled placeholder="请输入模板名称（限10字）" clearable class="flex_1"></el-input>
                    <el-link icon="el-icon-rank" type="primary" class="allowDrag m_l1" :underline="false"></el-link>
                    <el-link :underline="false" type="primary" class="el-icon-edit-outline m_l1" @click="addEdit(item.id, 'edit')"></el-link>
                    <el-link :underline="false" type="danger" class="el-icon-delete m_l1" :disabled="item.id == selTemplateId" @click="del(item.id)"></el-link>
                </div>
            </draggable>
        </div>
        <AddExportTemplate ref="addExportTemplate" @refreshDataList="refreshList()"></AddExportTemplate>
    </el-dialog>
</template>

<script>
    import draggable from "vuedraggable";
    import AddExportTemplate from "./addExportTemplate";

    export default {
        components: {draggable, AddExportTemplate},

        data() {
            return {
                visible: false,
                loading: false,
                selTemplateId: '',
                list: []
            }
        },
        methods: {
            init(selTemplateId) {
                this.selTemplateId = selTemplateId
                this.list = []
                this.visible = true
                this.refreshList()
            },
            refreshList() {
                this.loading = true
                this.$axios(this.api.metadata.allList).then(res => {
                    if(res.status) {
                        this.list = res.data
                    } else {
                        this.$message.error(res.msg)
                    }
                    this.loading = false
                })
            },
            // 新增修改
            addEdit(id, method) {
                if(method == 'add' && this.list.length >= 20) {
                    this.$message.warning('最多新增20条模板');
                    return
                }
                this.$refs.addExportTemplate.init(id, method)
            },
            // 删除
            del(id) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    this.$axios(this.api.metadata.updateDelFlagById + '/' + id).then(data => {
                        if (data.status) {
                            this.$message.success('删除成功');
                            this.$emit('refreshDataList')
                        } else {
                            this.$message.error(data.msg);
                        }
                        this.loading = false
                        this.refreshList();
                    })
                })
            },
            // 拖动排序
            onEnd() {
                this.loading = true
                let list = JSON.parse(JSON.stringify(this.list))
                list.map((item, index) => {
                    this.$set(item, 'modeSort', index+1)
                })
                this.$nextTick(() => {
                    this.$axios(this.api.metadata.updateSort, list, 'put').then(data => {
                        if (data.status) {
                            this.$message.success('排序成功');
                            this.$emit('refreshDataList')
                        } else {
                            this.$message.error('排序失败');
                        }
                        this.loading = false
                    })
                })
            },
            close() {
                this.$emit('refreshDataList')
            },
        }
    }
</script>

<style scoped>

</style>
